import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TimeSlotsFilters } from '../../../commons/models/timeslots';

@Component({
    selector: 'app-time-slots-filters',
    templateUrl: './time-slots-filters.component.html',
    styleUrls: ['./time-slots-filters.component.scss']
})
export class TimeSlotsFilterComponent{
    @Output()
      onFilter: EventEmitter<TimeSlotsFilters> = new EventEmitter();
    
      private _defaultFilters: TimeSlotsFilters;
      filtersForm: FormGroup;
    
      constructor(private fb: FormBuilder) {
        this._createForm();
      }
    
      private _createForm() {
        let group = {
          active: null,
          onlyCurrentTenant: [true]
        }
    
        this.filtersForm = this.fb.group(group);
      }
    
      applyFilters() {
        this.onFilter.emit(this._getFilters());
      }
      // applyFilters() {
      //   const filters = this._getPayment();
        
      //   let queryParams = `per_page=50&page=1`;
      
      //   // Controlla esplicitamente anche active === 0
      //   if (filters.active !== undefined && filters.active !== null) {
      //     queryParams += `&active=${filters.active}`;
      //   }
      
      //   console.log('URL della chiamata API:', queryParams);
      //   this.onFilter.emit(filters);
      // }
      
      
      
    
      private _getFilters(): TimeSlotsFilters {
        let filters: TimeSlotsFilters = {};
        if (this.filtersForm) {
            const values = this.filtersForm.value;
            filters.active = values.active !== null ? Number(values.active) : null;
            filters.onlyCurrentTenant = values.onlyCurrentTenant;
        }
        return filters;
      }
    
  
  
    resetFilters() {
      this.filtersForm.reset();
      this.filtersForm.patchValue({
        active: null,
        onlyCurrentTenant: true
      });
      //console.log('Valori dopo reset:', this.filtersForm.value);
      this._setDefaultValues();
      this.applyFilters();
    }
  
    get defaultFilters(): TimeSlotsFilters {
      return this._defaultFilters;
    }
  
    @Input()
    set defaultFilters(defaultFilters: TimeSlotsFilters) {
      this._defaultFilters = defaultFilters;
      this._setDefaultValues();
    }
  
    private _setDefaultValues() {
      if (this.defaultFilters) {
        if (this.filtersForm) {
          this.filtersForm.patchValue({
            active: this.defaultFilters.active,
            onlyCurrentTenant: this.defaultFilters.onlyCurrentTenant
          })
        }
      }
    }

}